"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cusano-milanino": {
    "26908127": [{
      "hkey": "4e0582cf",
      "slug": "cusano-milanino",
      "name": "Cusano Milanino",
      "primary": true,
      "skipSearch": false
    }],
    "citta-giardino-di-milanino": [{
      "hkey": "4e0582cf",
      "slug": "cusano-milanino",
      "name": "Cusano Milanino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;